// src/mediator/mediatorInstance.js

import { Mediator } from "./Mediator.js";
import { EventDebugger } from "./EventDebugger.js";
import { TimeoutRegistry } from "./TimeoutRegistry.js";

// Zentrale Mediator-Instanz
export const mediator = new Mediator();
export const timeoutRegistry = TimeoutRegistry;
export const eventDebugger = new EventDebugger(mediator);

// Event-Debugging aktivieren (nur im Dev-Modus empfohlen)
timeoutRegistry.attachMediator(mediator);
eventDebugger.enableDefaultWatchList();

// Optional für globale Debug-Zugriffe
if(typeof window !== 'undefined') {
    window.Mediator = mediator;
    window.TimeoutRegistry = TimeoutRegistry;
    window.EventDebugger = eventDebugger;
}